/* eslint-disable global-require */
var translations = {
  en: require('../locales/en'),
  zh: require('../locales/zh')
};
module.exports = {
  languages: [{
    value: 'en',
    text: 'ENG'
  }, {
    value: 'zh',
    text: '中文'
  }],
  getTranslator: function getTranslator(intl) {
    return function (id, variables) {
      if (variables === void 0) {
        variables = {};
      }

      return intl.formatMessage({
        id: id
      }, variables);
    };
  },
  translations: translations
};